import { service } from '../../helpers';

export const FETCH_HAS_ERROR = 'auth/FETCH_HAS_ERROR';
export const FETCH_IS_LOADING = 'auth/FETCH_IS_LOADING';
export const FETCH_SUCCESS = 'auth/FETCH_SUCCESS';
export const LOGOUT = 'auth/LOGOUT';

const initialState = {
  hasError: false,
  isLoading: false,
  loaded: false,
  token: null,
  user: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_HAS_ERROR:
      return {
        hasError: true,
        isLoading: false,
        loaded: false,
        error: action.error,
      };

    case FETCH_IS_LOADING:
      return { ...state, ...{ isLoading: action.isLoading } };

    case FETCH_SUCCESS:
      return {
        hasError: false,
        isLoading: false,
        loaded: true,
        token: action.token,
        user: action.user,
      };
    case LOGOUT:
      return initialState;

    default:
      return state;
  }
}

export function logOut() {
  return {
    type: LOGOUT,
  };
}

export function fetchError(error) {
  return {
    type: FETCH_HAS_ERROR,
    error,
  };
}

export function fetchIsLoading(bool) {
  return {
    type: FETCH_IS_LOADING,
    isLoading: bool,
  };
}

export function fetchSuccess(data) {
  return {
    type: FETCH_SUCCESS,
    token: data.token,
    user: data.user,
  };
}

export function doLogin(url, data) {
  return (dispatch) => {
    service
      .post(url, data)
      .then((responseData) => dispatch(fetchSuccess(responseData)))
      .catch((error) => dispatch(fetchError(error)));
  };
}
